import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  setupSectionWrapper: {
    width: '400px',
    display: 'flex',
    padding: '20px',
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    flex: 0.2,
    gap: '16px',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '20px',
    },
  },
  setupTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  setupDescriptionText: {
    color: '#040C14',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '25px',
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
  },
  calendarConnectBtn: {
    color: '#FFFFFF',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '24px',
    maxWidth: '320px',
    width: '100%',
  },

  calendarItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '32px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '16px',
    },
  },
  connectBtn: {
    color: '#89CC21',
    fontSize: '14px',
    fontWeight: 600,
    width: 120,
    height: 48,
    backgroundColor: 'rgb(241, 250, 233, 1)',
    border: 'none',
    '&:hover': {
      backgroundColor: '#e3facf',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  dialogContent: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      padding: theme.spacing(2),
      textAlign: 'center',
    },
  },
  dialogRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    textAlign: 'center',
  },
  dialogBoxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '360px',
    maxWidth: '500px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '340px',
      height: '460px',
      justifyContent: 'flex-start',
    },
  },
}));
